import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = loading, false = guest, obj = user
  const [token, setToken] = useState(localStorage.getItem("kx_token") || null);

  useEffect(() => {
    // If returning from Emergent OAuth, AuthCallback will handle the session exchange.
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (window.location.hash?.includes("session_id=")) {
      return;
    }
    const check = async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch (e) {
        if (token) localStorage.removeItem("kx_token");
        setToken(null);
        setUser(false);
      }
    };
    check();
    // eslint-disable-next-line
  }, []);

  const persist = (data) => {
    localStorage.setItem("kx_token", data.token);
    setToken(data.token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    persist(data);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    persist(data);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/emergent-logout"); } catch (e) {}
    localStorage.removeItem("kx_token");
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, register, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
